import React, { Component } from 'react'
import '../container.css'

class KardesProjeler extends Component {

    render() {
        return (
            <div className="info-pages-container" style={{ alignItems: "flex-start" }}>
                <h2>4 Koldan Doğa</h2>
                <p>Orman, bozkır ve göl ekosistemlerini tanıtmayı, doğa koruma ve sürdürülebilirlik konularında temel
bir farkındalık oluşturmayı amaçlayan 4 Koldan Doğa projesi 2019 yılında TUBİTAK 4004 – Doğa
Eğitimi ve Bilim Okulları çağrısı kapsamında desteklenmiş ve ODTÜ yerleşkesinde gerçekleştirilmiştir
Proje bilgilerine <a href="https://odtudedogaegitimi.wordpress.com/" target="blank">https://odtudedogaegitimi.wordpress.com adresinden ulaşılabilir.</a> </p>
                <br></br>
                <h2>Gençlik ve Kent için Doğa</h2>
                <p>Erasmus+ Stratejik Ortaklıklar çerçevesinde desteklenen Gençlik ve Kent için Doğa projesi gençlerin
sürdürülebilirlik ve doğa koruma konularında bilgi ve becerilerle donatılarak güçlendirilmesini, özgün
doğa eğitimi programları oluşturmalarını ve uygulamalarını hedefleyen bir içeriğe sahiptir. Bu
çerçevede bir e-öğrenme ortamını da <a href="http://odtudedoga.org/" target="blank" >http://odtudedoga.org/</a> adresinde meraklıların hizmetine
sunmaktadır.</p>
                <br></br>
                <h2>EKOSAM Öğrenci Topluluğu-ODTÜ</h2>
                <p>Kent içinde doğa unsurlarını koruma uygulamalarının önemi hakkında bilinç oluşturmak ve bu
uygulamaları yaygınlaştırmak, doğa rehberleri yetiştirmek, sağlıklı ve sürdürülebilir doğa-insan ve
doğa-kent ilişkilerinin kurulmasına zemin hazırlamak amacıyla çalışmalar yapmayı hedefleyen
topluluk 2019 yılında kurulmuştur.</p>
                <br></br>
                <h2>Doğa Koruma Merkezi</h2>
                <p>2004 yılından beri &#39;koruma biyolojisi&#39; disiplinini temel alarak doğa koruma alanında ulusal ve
uluslararası ortaklarının desteği ile Türkiye&#39;nin dört bir yanında çalışmalarına devam eden bir sivil
toplum kuruluşudur. Merkezin amacı; bilimsel yaklaşımları temel alarak, biyolojik çeşitliliğin etkin
şekilde korunmasını ve doğal kaynakların sürdürülebilir şekilde yönetilmesini sağlamaktır. Merkez ve
çalışmaları hakkında ayrıntılı bilgilere <a href="https://www.dkm.org.tr/" target="blank">https://www.dkm.org.tr</a> adresinden ulaşılabilir.</p>
                <br></br>
                <h2>Türkiye’nin Bitkileri</h2>
                <p>Türkiye’deki bitkilerle ilgili bilgi ve görsel veri toplamak, doğa gönüllülerine bir rehber oluşturmak ve
bu alanda farkındalık yaratmak amacıyla kurulan bu siteye <a href="https://www.turkiyebitkileri.com/tr/" target="blank">https://www.turkiyebitkileri.com/tr</a>
                    adresinden ulaşılabilir.</p>
                <br></br>
                <h2>iNaturalist</h2>
                <p>Dünyanın en popüler doğa uygulamalarından biri olan iNaturalist, doğada karşılaşılabilecek bitki ve
hayvanların tanımlanmasına yardımcı olan bir ortak platformdur. Doğada gözlenebilen türler
750.000'den fazla bilim insanı ve doğa bilimci topluluğu ile paylaşılarak doğayı daha iyi anlama ve
koruma yönünde araştırma verileri oluşturulmaktadır. Uygulama ile ilgili bilgilere
<a href="https://www.inaturalist.org/" target="blank">https://www.inaturalist.org</a> adresinden ulaşılabilir.</p>
            </div>
        )
    }
}

export default KardesProjeler